import { AppState } from '../meta-reducer/index';
import { Store } from '@ngrx/store';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { Injectable } from "@angular/core"
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as NotificationActions from './notification.action';
import { of } from 'rxjs';
import { RecognitionApiService } from '../../providers/api.service/recognition.api.service';

@Injectable()
export class RecentActivityEffects {
  private existingPayload: { unseenCount: number, hasPreviousNotification: boolean };

  constructor(private actions$: Actions, private store: Store<AppState>, private _recognitionApiService: RecognitionApiService) { }


  loadActivity$ = createEffect(() => this.actions$
    .pipe(
      ofType(NotificationActions.recentActivityRequested),
      mergeMap((action) => {
        this.existingPayload = action.existingPayload;
        return this._recognitionApiService.getNotificationsList(action.query).pipe(
          catchError(error => {
            this.store.dispatch(NotificationActions.recentActivityLoadingError({ errorMessage: error.message }));
            return of({
              data: []
            });
          }),
        )
      }),
      map(response => {
        let { data } = response;
        return NotificationActions.recentActivityLoaded({ recentActivities: data?.data, hasNotifications: false, mentionsCount: 0, remindersCount: 0, recommendationsCount: 0, allCount: 0 })
      }),
    ))
}

